module.exports = __webpack_public_path__ + "img/CM-PW-25-Kia-Modern.35032228.jpg";